import styled from 'styled-components';
import { Col as AntdCol } from 'antd';
import { Button as StyledButton, Button2 } from '../../../../../styles/buttons';

export const Label = styled.label`
  font-size: 18px;
  font-weight: bold;
`;

export const Col = styled(AntdCol)`
  margin-bottom: 0.8rem;

  input {
    width: 100%;
    height: 2rem;
    padding: 0 11px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;

    &:focus,
    &:hover {
      border-color: ${(props) => props.theme.colors.cyanDark};
      outline-color: transparent;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgb(22 158 173 / 20%);
    }
  }

  @media (max-width: 768px) {
    min-width: 0em;
  }
`;

export const InputView = styled.div`
  margin-bottom: 0.8rem;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 2px;
  color: rgba(0, 0, 0, 0.75);
`;

export const ErrorText = styled.span`
  color: #dc3545;
  font-size: 12px;
  display: block;
  margin-top: 2px;
`;

export const Button = styled(Button2)`
  margin-top: 20px;
  width: 100%;
  border-radius: 20px;
`;

export const ResetButton = styled(StyledButton)`
  margin-top: 20px;
  width: 100%;
  border-radius: 20px;
`;

export const Form = styled.form``;
